<div class="row">
  @if (dataSource.loading$ | async) {
    <div  class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  }

  @if (dataSource.error$ | async) {
    <div class="alert alert-danger">
      <div class="row">
        <h4>Error loading table</h4>
        <p>{{dataSource.error$ | async}}</p>
      </div>
    </div>
  }
</div>

<div class="row">
  <div class="col-auto" style="align-items: center; justify-content: flex-start; display: flex;">
    <span class="header-text">Quick search:&nbsp;</span>
    <input class="form-control" placeholder="Search..." aria-label="Search" #searchBox>
  </div>

  <div class="col-auto" style="align-items: center; justify-content: flex-start; display: flex; padding-left: 0px !important;">
    <button style="border-width: 0px; background-color: transparent;" (click)="clearSelection()" title="Clear filters">
      <mat-icon class="primary-icon"  style="">delete_sweep</mat-icon>
      <span class="header-text">Clear filters</span>
    </button>
  </div>

  <div class="col-auto" style="align-items: center; justify-content: flex-start; display: flex; padding-left: 0px !important;">
    <button digby-table-column-sorter
      [(columns)]="displayedColumns"
      [columnInfo]="allColumns"
      [saveName]="'gen-sample-table'"
      (columnsChange)="updateColumnData($event)" id="colbutton" title="Select data">
      <mat-icon class="primary-icon"  style="padding-left: 0px !important;">view_column</mat-icon>
    </button>
    <label class="form-check-label" for="colbutton">Select data</label>
  </div>

  <div class="col-auto" style="align-items: center; justify-content: flex-start; display: flex; padding-left: 0px !important;">
    <button style="border-width: 0px; background-color: transparent;" [matMenuTriggerFor]="downloadMenu" id="downloadbutton" title="Download options">
      <mat-icon class="primary-icon"  style="">cloud_download</mat-icon>
    </button>
    <label class="form-check-label" for="downloadbutton">Download</label>
  </div>

  @if (selectedSequenceNames.length) {
    <div class="col-auto" style="align-items: center; justify-content: flex-start; display: flex;">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="chk-selected-items" style="margin-top: .1rem;"
          [(ngModel)]="isSelectedSamplesChecked"
          (change)="(onSelectedSamplesChange())"
          >
          <label class="form-check-label" for="chk-selected-items">
            Only records with selected genes
          </label>
        </div>
      </div>
    }

    <div class="col-auto ms-auto">
      <mat-paginator [length]="dataSource?.totalItems" [pageSize]="25" [pageSizeOptions]="[25, 50, 100, 250]"></mat-paginator>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <table mat-table [dataSource]="dataSource" appTableResize="gen-sample-table-widths">
        @for (col of allColumns; track col.id) {
          @if ((col.type === 'string')) {
            <ng-container matColumnDef={{col.id}}>
              <mat-header-cell class="{{col.size}}" *matHeaderCellDef appColumnResize>
                <div class="header-flex-tight">
                  <span class="column-title">{{col.name}}</span>
                  @if (col.id === 'sample_name') {
                    <div >
                      <app-filter #filterComponent="menuInOtherComponent" [columnName]="col.id" [filterMode]="filterModeEnum.TEXT_MODE" [setFilter$] = "setFilter$" [clear$] = "clear$" [choices$]="dataSource.choices$" (predicateEmitter)="applyFilter($event)"></app-filter>
                    </div>
                  }
                  @if (col.id !== 'sample_name') {
                    <div >
                      <app-filter #filterComponent="menuInOtherComponent" [columnName]="col.id" [filterMode]="filterModeEnum.TEXT_MODE" [clear$] = "clear$" [choices$]="dataSource.choices$" (predicateEmitter)="applyFilter($event)"></app-filter>
                    </div>
                  }
                </div>
              </mat-header-cell>
              @if (col.id === 'annotation_path') {
                <div >
                  <mat-cell *matCellDef="let item" class="small-col">
                    @if (item[col.id].length > 0) {
                      <button class="btn btn-sm" style="" [matMenuTriggerFor]="genoMenu" [matMenuTriggerData]="{sample: item}" title="View genotype details">
                        <i class="fa fa-folder fa-5" style="line-height: inherit;"></i>
                      </button>
                    }
                    @if (item[col.id].length === 0) {
                      NA
                    }
                  </mat-cell>
                </div>
              }
              @if (col.id === 'sample_name') {
                <div>
                  <mat-cell class="{{col.size}}" *matCellDef="let item" (click)="showInfo(item)">
                    {{item[col.id]}}
                  </mat-cell>
                </div>
              }
              @if (col.id !== 'annotation_path' && col.id !== 'sample_name') {
                <div>
                  <mat-cell class="{{col.size}}" *matCellDef="let item">
                    @if (item[col.id] && item[col.id].startsWith('http')) {
                      <a href={{item[col.id]}}><i class="fa fa-external-link" style="line-height: inherit;"></i></a>
                    }
                    @if (!(item[col.id] && item[col.id].startsWith('http'))) {
                      {{item[col.id]}}
                    }
                  </mat-cell>
                </div>
              }
            </ng-container>
          }
          @if ((col.type === 'integer' || col.type === 'number')) {
            <ng-container matColumnDef={{col.id}}>
              <mat-header-cell class="{{col.size}}" *matHeaderCellDef appColumnResize>
                <div class="header-flex-tight">
                  <span class="column-title">{{col.name}}</span>
                  <app-filter #filterComponent="menuInOtherComponent" [columnName]="col.id" [filterMode]="filterModeEnum.NUMBER_MODE" [clear$] = "clear$" [choices$]="dataSource.choices$" (predicateEmitter)="applyFilter($event)"></app-filter>
                </div>
              </mat-header-cell>
              <mat-cell class="{{col.size}}" *matCellDef="let item">
                {{item[col.id]}}
              </mat-cell>
            </ng-container>
          }
          @if ((col.type === 'boolean')) {
            <ng-container matColumnDef={{col.id}}>
              <mat-header-cell class="{{col.size}}" *matHeaderCellDef appColumnResize>
                <div class="header-flex-tight">
                  <span class="column-title">{{col.name}}</span>
                  <app-filter #filterComponent="menuInOtherComponent" [columnName]="col.id" [filterMode]="filterModeEnum.BOOL_MODE" [clear$] = "clear$" [choices$]="dataSource.choices$" (predicateEmitter)="applyFilter($event)"></app-filter>
                </div>
              </mat-header-cell>
              <mat-cell class="{{col.size}}" *matCellDef="let item">
                @if (item[col.id]) {
                  <i class="fa fa-check" style="line-height: inherit;"></i>
                }
              </mat-cell>
            </ng-container>
          }
        }

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="mat-elevation-z1"></mat-header-row>

        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

      </table>
    </div>
  </div>


  <mat-menu #genoMenu="matMenu" xPosition="before" class="menu-overflow-hidden">
    <div  (click) = "$event.stopPropagation()">
      <ng-template matMenuContent let-sample="sample">
        <div class="container">
          <div class="d-flex align-items-center ms-1 me-2">
            <b>{{sample.name}}</b>
          </div>
          <div class="d-flex align-items-center ms-1 me-2 mb-1">
            Genotype Analysis
            <span>&nbsp;&nbsp;</span>
            <button class="btn btn-sm addr" (click)="sendReportRequest('rep_single_genotype', 'pdf', sample)" title="Download PDF report">
              <i class="fa fa-file-pdf-o" style="line-height: inherit;" ></i>
            </button>
            <span>&nbsp;&nbsp;</span>
            <button class="btn btn-sm addr" (click)="sendReportRequest('rep_single_genotype', 'html', sample)" title="View HTML report">
              <i class="fa fa-desktop" style="line-height: inherit;"></i>
            </button>
          </div>
          @if (sample.annotation_method=='IGenotyper') {
            <div class="d-flex align-items-center ms-1 me-2 mb-1">
              IGenotyper
            </div>
            <div class="d-flex align-items-center ms-4 me-2 mb-0 align-middle">
              Annotation<span>&nbsp;&nbsp;</span><a href="{{sample.annotation_path}}" target="_blank" rel="noopener" title="Download annotation"><i class="fa fa-save" style="line-height: inherit;"></i></a>
            </div>
            <div class="d-flex align-items-center ms-4 me-2 mb-0 align-middle">
              Contigs: BAM<span>&nbsp;&nbsp;</span><a href="{{sample.contig_bam_path}}" target="_blank" rel="noopener" title="Download BAM file"><i class="fa fa-save" style="line-height: inherit;"></i></a>
              <span>&nbsp;&nbsp;</span>BAI<span>&nbsp;&nbsp;</span><a href="{{sample.contig_bam_path.replace('.bam', '.bam.bai')}}" target="_blank" rel="noopener" title="Download BAI file"><i class="fa fa-save" style="line-height: inherit;"></i></a>
            </div>
            <div class="d-flex align-items-center ms-4 me-2 mb-1">
              Documentation<span>&nbsp;&nbsp;</span>
              <a href="{{sample.annotation_reference}}" target="_blank" rel="noopener" title="View documentation"><i class="fa fa-desktop" style="line-height: inherit;"></i></a>
            </div>
          }
          @if (sample.annotation_method=='Digger') {
            <div class="d-flex align-items-center ms-1 me-2 mb-1">
              Digger
            </div>
            <div class="d-flex align-items-center ms-4 me-2 mb-0 align-middle">
              Annotation<span>&nbsp;&nbsp;</span><a href="{{sample.annotation_path}}" target="_blank" rel="noopener" title="Download annotation"><i class="fa fa-save" style="line-height: inherit;"></i></a>
            </div>
            <div class="d-flex align-items-center ms-4 me-2 mb-0 align-middle">
              Contigs<span>&nbsp;&nbsp;</span><a href="{{sample.contig_bam_path}}" target="_blank" rel="noopener" title="Download contigs"><i class="fa fa-save" style="line-height: inherit;"></i></a>
              <span>&nbsp;&nbsp;</span>
            </div>
            <div class="d-flex align-items-center ms-4 me-2 mb-1">
              Documentation<span>&nbsp;&nbsp;</span>
              <a href="{{sample.annotation_reference}}" target="_blank" rel="noopener" title="View documentation"><i class="fa fa-desktop" style="line-height: inherit;"></i></a>
            </div>
          }
          @if (sample.annotation_method=='VDJbase') {
            <div class="d-flex align-items-center ms-2 me-2 mb-1">
              VDJbase
            </div>
            <div class="d-flex align-items-center ms-4 me-2 mb-0 align-middle">
              Annotation<span>&nbsp;&nbsp;</span><a href="{{sample.annotation_path}}" target="_blank" rel="noopener" title="Download annotation"><i class="fa fa-save" style="line-height: inherit;"></i></a>
            </div>
            <div class="d-flex align-items-center ms-4 me-2 mb-1">
              Documentation<span>&nbsp;&nbsp;</span>
              <a href="{{sample.annotation_reference}}" target="_blank" rel="noopener" title="View documentation"><i class="fa fa-desktop" style="line-height: inherit;"></i></a>
            </div>
          }
        </div>
      </ng-template>
    </div>
  </mat-menu>

  <mat-menu #downloadMenu="matMenu" xPosition="before" class="menu-overflow-hidden">
    <ng-template matMenuContent>
      <div class="container">
        <div class="d-flex align-items-center ms-1 me-2">
          <b>Download data for selected samples</b>
        </div>
        <div class="d-flex align-items-center ms-4 me-2 mb-0 align-middle">
          Sample info (csv)
          <span>&nbsp;&nbsp;</span>
          <button class="btn btn-sm addr" (click)="sendReportRequest('download_gen_data', 'csv', {type:'Sample info (CSV)'})" title="Download CSV">
            <i class="fa fa-file-pdf-o" style="line-height: inherit;" ></i> </button>
          </div>
          <div class="d-flex align-items-center ms-4 me-2 mb-0 align-middle">
            Sample data (zip)
            <span>&nbsp;&nbsp;</span>
            <button class="btn btn-sm addr" (click)="sendReportRequest('download_gen_data', 'zip', {type:'Sample files (ZIP)'})" title="Download ZIP">
              <i class="fa fa-file-zip-o" style="line-height: inherit;" ></i> </button>
            </div>
          </div>
        </ng-template>
      </mat-menu>
